import { useEffect, useState } from 'react';
import { useGenerateNarrativeTitle } from './useGenerateNarrativeTitle';

type Variables = Parameters<
  ReturnType<typeof useGenerateNarrativeTitle>['mutateAsync']
>['0'];

export const useNarrativeTitleSuggestions = (input: Variables['input']) => {
  const [titles, setTitles] = useState<string[]>([]);
  const { mutateAsync: generateSuggestions, isPending } =
    useGenerateNarrativeTitle();

  useEffect(() => {
    setTitles([]);
  }, [
    input.companyId,
    input.contentHtml,
    input.fairValue,
    input.discountRate,
    input.futureSharesOutstanding,
    input.futurePePercentageChange,
    input.profitMarginPercentageChange,
    input.revenuePercentageChange,
    input.timeframe,
    input.sharesOutstandingGrowthRate,
  ]);

  return {
    isLoading: isPending,
    currentSuggestion: titles[0],

    nextSuggestion: async () => {
      let title = titles[1];

      if (!title) {
        const { generateNarrativeTitleSuggestions } = await generateSuggestions(
          { input, limit: 5 }
        );
        const newTitles = generateNarrativeTitleSuggestions.titles;
        title = newTitles[0];

        setTitles(newTitles);
      } else {
        setTitles(titles.slice(1));
      }

      if (!title) {
        throw new Error('Unable to get more suggestions');
      }

      return title;
    },
  };
};
